// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3j187","dragIcon":"SortableItem_dragIcon__2XBmL","disabled":"SortableItem_disabled__3s0ms"};